import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  switchWrapper: {
    padding: '6px',
  },

  switchTrack: {
    borderRadius: '12px',
  },

  switchCheckedTrack: {
    backgroundColor: theme.palette.primary.main,
  },

  switchBase: {
    color: theme.palette.background.default,
  },

  switchChecked: {
    color: theme.palette.primary.main,
  },

  switchRoot: {},
}));
